export default __webpack_public_path__ + "fbe22be525156a3787de0614b94b25a9.png";